import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MenuItem, OverlayTrigger, Tooltip, Dropdown } from 'react-bootstrap';
import { truncate, filter } from 'lodash';
import styles from '../Header/Header.css';
import Fa from 'react-fontawesome';
import SearchField from '../../../../components/search-field';

// Import Actions
import { searchOrganization, requestPretentOrganization } from '../../../Auth/AuthActions';
import { resetAll } from '../../../Team/TeamActions';

// Import Selectors
import { getUser } from '../../../Auth/AuthReducer';
import enhanceWithClickOutside from 'react-click-outside';
import UserAvatar from 'react-user-avatar';

const maxChars = 20;

class OrganizationSwitcher extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
      loaded: false,
      loading: false,
      organizations: [],
      query: null,
      currentSwitchingOrgId: null,
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleOrganizationSelect = this.handleOrganizationSelect.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }

  handleClickOutside() {
    this.setState({ open: false });
  }

  handleToggle(open) {
    if (!this.state.open) {
      this.setState({ open });
    }
    if (open && !this.state.loaded && !this.state.loading) {
      this.setState({ loading: true });
      this.props.dispatch(searchOrganization({}))
        .then(
          (results) => {
            this.setState({
              loading: false,
              loaded: true,
              organizations: results.organizations ? results.organizations.items : [],
            });
          },
          () => {
            this.setState({
              loading: false,
              organizations: [],
            });
          },
        );
    }
  }

  handleOrganizationSelect(orgId) {
    this.setState({ currentSwitchingOrgId: orgId });
    return this.props.dispatch(requestPretentOrganization(orgId))
      .then(
        () => {
          window.location.reload();
          /*
          this.props.dispatch(resetAll());
          this.setState({ open: false, currentSwitchingOrgId: null, loaded: false });
          */
        },
        () => {
          this.setState({ open: false, currentSwitchingOrgId: null });
        },
      );
  }

  handleSearch(query) {
    this.setState({ query });
  }
  renderOrgItem(org) {
    const { user } = this.props;
    const { currentSwitchingOrgId } = this.state;
    const organization = user.pretent_organization || user.organization;
    const displayName = org.display_name || org.name;
    const name = truncate(displayName, { length: maxChars });
    const isLong = name.length !== displayName.length;
    const id = org._id;
    const tooltip = isLong ? (<Tooltip id={id}>{displayName}</Tooltip>) : null;
    const isActive = org._id === organization._id;
    return (<MenuItem active={isActive} eventKey={id} key={id} onSelect={this.handleOrganizationSelect}>
      <div className="clearfix" style={{ minWidth: 200 }}>
        <div className="pull-left">
          {currentSwitchingOrgId === id && <span><Fa name="spinner" className="text-muted" spin />&nbsp;</span>}
          {currentSwitchingOrgId !== id && <UserAvatar
            borderRadius="2px"
            name={displayName}
            size="16"
          />}
        </div>
        <div className="pull-left">
          {isLong && <OverlayTrigger placement="right" overlay={tooltip}><span>{name}</span></OverlayTrigger>}
          {!isLong && <span>{name}</span>}
        </div>
        <div className="pull-right">
          {org.is_demo && <small className="badge">Demo</small>}
        </div>
      </div>
    </MenuItem>);
  }
  render() {
    const { user } = this.props;
    const {
      open, loaded, loading, organizations, query,
    } = this.state;
    const isLogin = user && user._id;
    const hasData = !loading && loaded && organizations.length > 0;

    if (isLogin) {
      const organization = user.pretent_organization || user.organization;
      const active = user.pretent_organization && user.pretent_organization._id !== undefined &&
        user.organization._id !== user.pretent_organization._id;
      const myOrgId = user.organization._id;
      let isMyOrgMatch = true;
      let sortedData = organizations;
      const re = query && query.trim().length ? new RegExp(query, 'i') : null;
      sortedData = filter(sortedData, (data) => {
        let matchedKeyword = true;
        if (re) {
          const name = data.display_name || data.name || '';
          matchedKeyword = name.match(re);
        }
        if (!matchedKeyword && data._id === myOrgId) {
          isMyOrgMatch = false;
        }
        return matchedKeyword;
      });
      const masterTitle = organization.display_name || organization.name;
      const masterShortTitle = truncate(masterTitle, { length: maxChars });
      const isMasterTitleLong = masterTitle.length !== masterShortTitle.length;
      const masterTooltip = isMasterTitleLong ? (<Tooltip id="master-tooltip">{masterTitle}</Tooltip>) : null;

      return (
        <Dropdown
          className={styles.navDropdown}
          onToggle={this.handleToggle}
          open={open}
          componentClass="li"
          id="org-switcher-drop-down"
        >
          {!open && <div className={styles.dropdownToggleMain} onClick={() => { this.handleToggle(!open); }}>
            {isMasterTitleLong && <OverlayTrigger placement="bottom" overlay={masterTooltip}><span>{masterShortTitle}</span></OverlayTrigger>}
            {!isMasterTitleLong && <span>{masterShortTitle}</span>}
            &nbsp;
            <Fa name="caret-down" />
          </div>}
          {open && <div className={styles.dropdownToggleMain}>
            <div className={styles.searchMenu}>
              <SearchField autoFocus collapsible={false} onSearch={this.handleSearch} query={query} />
              &nbsp;
              {!loading && <Fa name="caret-down" onClick={() => { this.handleClickOutside(); }} />}
              {loading && <Fa name="spinner" spin onClick={() => { this.handleClickOutside(); }} />}
            </div>
          </div>}
          <Dropdown.Toggle className={styles.dropdownToggle} />
          <Dropdown.Menu className={loading ? 'invisible' : null}>
            {hasData && isMyOrgMatch && this.renderOrgItem(user.organization)}
            {hasData && isMyOrgMatch && sortedData.length > 1 && <MenuItem divider />}
            {hasData && sortedData.map((org) => {
              if (myOrgId !== org._id) {
                return this.renderOrgItem(org);
              }
              return null;
            })}
            {hasData && sortedData.length === 0 && <MenuItem disabled>
              <span>No Records Found.</span>
            </MenuItem>}
          </Dropdown.Menu>
        </Dropdown>
      );
    }
    return null;
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    user: getUser(state),
  };
}

OrganizationSwitcher.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};
OrganizationSwitcher.defaultProps = {
};
export default connect(mapStateToProps)(enhanceWithClickOutside(OrganizationSwitcher));
